// ============================================================
// HOW LOUD THE MOVEMENT BANDS ARE DRAWN (2026-10-21: "test with different
// levels of intensity for the movement rings"; the user picked "Quiet as a
// setting" on the canvas's MoveRings artboard).
//
// A viewer's own choice, and the DRAWING only: where a figure may go, the
// pace a move is logged at and every other screen's lines are untouched.
//   off   - no bands and no reach fill; dangerous ground is still marked,
//           and a dragged route still shows;
//   quiet - hairlines that fade outward, Charge and Run dashed, a breath of
//           fill: the default;
//   full  - as they always were.
//
// The default (Quiet) and the validation are the settings registry's row
// (`movementBands`), read through `enumValue`. Pure. Zero React dependency.
// ============================================================

export type MovementBandLook = 'off' | 'quiet' | 'full';

export const MOVEMENT_BAND_LOOKS: { key: MovementBandLook; label: string; hint: string }[] = [
  { key: 'off', label: 'Off', hint: 'No bands on the map; dangerous ground is still marked' },
  { key: 'quiet', label: 'Quiet', hint: 'Hairlines, fainter band by band outward; a breath of fill' },
  { key: 'full', label: 'Full', hint: 'The bands as bright lines over a tinted reach' },
];
